export type ReportStatus = 'SUCCESS' | 'ERROR' | 'IN_PROGRESS';

export const deriveWorstStatus = (statuses: string[]): ReportStatus => {
  if (statuses.includes('ERROR')) return 'ERROR';
  if (statuses.includes('IN_PROGRESS')) return 'IN_PROGRESS';
  return 'SUCCESS';
};

type AggregatableRun = {
  status: string;
  totalValid?: number | null;
  totalFailed?: number | null;
  runAt?: string | number | null;
};

export type RunAggregate = {
  statuses: string[];
  totalValid: number;
  totalFailed: number;
  latestRunAt: string | number;
};

// Items arrive pre-sorted DESC by runAt from the server
// (runStatuses(first: 10, sort: { runAt: DESC })). Return the first non-null
// item instead of re-sorting client-side: Timestamp scalars may be returned as
// numbers at runtime, making string comparison unreliable.
export const latestRunStatus = <T>(
  items: (T | null)[] | null | undefined
): T | null => {
  if (!items) return null;
  for (const item of items) {
    if (item) return item;
  }
  return null;
};

export const aggregateRuns = (
  runs: (AggregatableRun | null | undefined)[]
): RunAggregate => {
  const statuses: string[] = [];
  let totalValid = 0;
  let totalFailed = 0;
  let latestRunAt: string | number = '';
  let latestRunAtMs = 0;
  for (const run of runs) {
    if (!run) continue;
    statuses.push(run.status);
    totalValid += Number(run.totalValid ?? 0);
    totalFailed += Number(run.totalFailed ?? 0);
    if (run.runAt != null) {
      const ms = new Date(run.runAt).getTime();
      if (!Number.isNaN(ms) && ms > latestRunAtMs) {
        latestRunAtMs = ms;
        latestRunAt = run.runAt;
      }
    }
  }
  return { statuses, totalValid, totalFailed, latestRunAt };
};
